/* eslint-disable */
import toastr from 'toastr';
import Authorization from './Authorization';
import Utility from './Utility';
import Env from './env';
import { ls } from './LocalStorage';
import {
 fetchWithXsrf as sharedFetchWithXsrf,
 getRefreshVersion,
 refreshSessionIfNeeded,
 logoutOnce as sharedLogoutOnce,
} from './services/SessionManager';

class RequestFactory {
  /**
   * static class property to hold various service avaliable
   *
   * @var array
   */
  static LOCALHOST = 'localhost';

  /**
   * static class property to hold various request body types avaliable
   *
   * @var string
   */
  static REQUEST_BODY_TYPE_FORM_DATA = 'FormData';

  static REQUEST_BODY_TYPE_RAW = 'Raw';

  static REQUEST_BODY_TYPE_JSON = 'Json';

  static REQUEST_BODY_TYPE_IMAGE = 'Image';

  /**
   * static class property to hold the request body type available
   *
   * @var array
   */
  static requestBodyTypes = ['FormData', 'Raw', 'Json', 'Image'];

  /**
   * static class property to hold the available services
   *
   * @var object
   */
  static services = {
    BASE_API: 'REACT_APP_BACKEND_BASE_URL_V2',
    V3_API: 'REACT_APP_BACKEND_BASE_URL_V3',
  };

  /**
   * static class property to hold the unallowed request params
   *
   * @var array
   */
  static unallowedRequestParamKeys = ['inputErrors'];

  constructor() {
    /*
     * Environment variables are loaded at build time.
     */
    this.resetFactory();

    /**
     * 
     * DEBUG
     * 
     */
    this.DEBUG_AUTH_FLOW = true;

    this.requestCounter = 0;
  }

  /**
   * 
   * DEBUG HELPERS
   * 
   */

  debugLog(...args) {
    if (this.DEBUG_AUTH_FLOW) {
      console.log('[RequestFactory]', ...args);
    }
  }

  debugWarn(...args) {
    if (this.DEBUG_AUTH_FLOW) {
      console.warn('[RequestFactory]', ...args);
    }
  }

  debugError(...args) {
    if (this.DEBUG_AUTH_FLOW) {
      console.error('[RequestFactory]', ...args);
    }
  }

  getRequestId() {
    this.requestCounter += 1;

    return `REQ-${this.requestCounter}`;
  }

  /**
   * set this service current request made with
   *
   * @param service
   * @return this
   */
  withService(service) {
    this.service = service;

    return this;
  }

  /**
   * check request is failed due to network connection
   *
   * @param responseMessage
   * @return boolean
   */
  isFetchFailure(responseMessage) {
    return (
      responseMessage === 'Failed to fetch' ||
      responseMessage === 'NetworkError when attempting to fetch resource.' ||
      responseMessage === 'Network request failed'
    );
  }

  /**
   * set headers for current request
   *
   * @param key
   * @param value
   * @return this
   */
  setHeaders(key, value) {
    this.headers.set(key, value);

    return this;
  }

  /**
   * remove headers from existing for current request
   *
   * @param key
   * @return this
   */
  removeHeaders(key) {
    if (this.headers.has(key)) {
      this.headers.delete(key);
    }

    return this;
  }

  /**
   * set this service current request made with
   *
   * @param service
   * @return this
   */
  withRequestBodyType(requestBodyType) {
    this.requestBodyType = requestBodyType;

    return this;
  }

  /**
   * reset this property default for request
   *
   * @return void
   */
  resetFactory() {
    this.headers = new Headers({
      Accept: '*/*',
      Pragma: 'no-cache',
      'Cache-Control': 'no-cache, no-store',
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
    });

    this.service = RequestFactory.DEVICES;

    this.requestBodyType = RequestFactory.REQUEST_BODY_TYPE_FORM_DATA;
  }

  /**
   * check key is allowed for request param
   *
   * @param key
   * @return boolean
   */
  isAllowedRequestParamKey(key) {
    return RequestFactory.unallowedRequestParamKeys.indexOf(key) === -1;
  }

  /**
   * 
   * GET HEADERS
   *
   * Authentication is cookie based.
   *
   * Do not add Authorization/access token here.
   *
   * Browser authentication is handled through:
   *
   * credentials: 'include'
   */
  getHeaders() {
    const headers = new Headers(this.headers);

    const user = Authorization.getAuthUserId();
    const userRole = Authorization.getAuthUserRole();

    const userId = ls.getItem('csSupportRequestedLoggedInUserId');
    const userRoleSupport = ls.getItem('csSupportRequestedLoggedInRole');
    const getCdsRequestByProfile = ls.getItem('cdsRequests');
    const getProflieBystatus = ls.getItem('profStatus');

    if (Env.env.REACT_APP_API_KEY) {
      headers.set('key', Env.env.REACT_APP_API_KEY);
    }

    if (user) {
      headers.set('AuthUser', `${user}`);
    }

    if (userRole) {
      headers.set('Role', `${userRole}`);
    }
    if (userRole === 'CSSUPPORT') {
      if (userId) {
        headers.set('csSupportRequestedLoggedInUserId', `${userId}`);
      }

      if (userRoleSupport) {
        headers.set('csSupportRequestedLoggedInRole', `${userRoleSupport}`);
      }
    }

    if (getCdsRequestByProfile) {
      headers.set('cdsUserId', `${user}`);
      if (getProflieBystatus) {
        headers.set('profileStatus', `${getProflieBystatus}`);
      }
    }

    return headers;
  }

  /**
   * get base api url
   *
   * @return string
   */
  getBaseApiUrl() {
    return Env.getEnv(RequestFactory.services.BASE_API);
  }
  getBaseApiUrlV3() {
    return Env.getEnv(RequestFactory.services.V3_API);
  }

  /**
   * convert the object to raw data(string) by
   * Serialize the object with url encode
   * used when form data is not prepared for request body
   * require jquery
   * to work without jquery modify logic defined
   *
   * @param object
   * @return object
   */
  convertObjectToRawData(obj) {
    return JSON.stringify(obj);
  }

  /**
   * filter the request paran
   * remove the unallowed request params
   *
   * @param object
   * @return object
   */
  filterRequestParam(data) {
    if (
      typeof data === 'object' &&
      data !== null &&
      Object.keys(data).length > 0
    ) {
      RequestFactory.unallowedRequestParamKeys.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          delete data[key];
        }
      });
    }

    return data;
  }

  /**
   * get base api url
   *
   * @param object
   * @return object
   */
  getRequestBody(data) {
    data = this.filterRequestParam(data);
    switch (this.requestBodyType) {
      /*
       * RAW and JSON previously performed exactly
       * the same operation.
       */
      case RequestFactory.REQUEST_BODY_TYPE_RAW:
      case RequestFactory.REQUEST_BODY_TYPE_JSON:
        return this.convertObjectToRawData(data);

      case RequestFactory.REQUEST_BODY_TYPE_IMAGE:
        return data;

      case RequestFactory.REQUEST_BODY_TYPE_FORM_DATA:
      default: {
        const body = new FormData();

        Object.keys(data || {}).forEach((key) => {
          body.append(key, data[key]);
        });

        return body;
      }
    }
  }

  /**
   * get request
   * @param url
   * @param successCallback
   * @param errorCallback
   * @param queryParams
   * @return void
   */
  get(url, successCallback, errorCallback, queryParams) {
    return this.request(
      this.getUrl(url, queryParams),
      {
        method: 'GET',
        headers: this.getHeaders(),
        mode: 'cors',
      },
      successCallback,
      errorCallback
    );
  }

  /**
   * post request
   * @param url
   * @param data
   * @param successCallback
   * @param errorCallback
   * @param queryParams
   * @return void
   */
  post(url, data, successCallback, errorCallback, queryParams) {
    return this.request(
      this.getUrl(url, queryParams),
      {
        method: 'POST',
        headers: this.getHeaders(),
        body: this.getRequestBody(data),
      },
      successCallback,
      errorCallback
    );
  }

  /**
   * put request
   * @param url
   * @param data
   * @param successCallback
   * @param errorCallback
   * @param queryParams
   * @return void
   */
  put(url, data, successCallback, errorCallback, queryParams) {
    return this.request(
      this.getUrl(url, queryParams),
      {
        method: 'PUT',
        headers: this.getHeaders(),
        body: this.getRequestBody(data),
      },
      successCallback,
      errorCallback
    );
  }

  /**
   * delete request
   * @param url
   * @param data
   * @param successCallback
   * @param errorCallback
   * @param queryParams
   * @return void
   */
  delete(url, data, successCallback, errorCallback, queryParams) {
    return this.request(
      this.getUrl(url, queryParams),
      {
        method: 'DELETE',
        headers: this.getHeaders(),
        body: this.getRequestBody(data),
      },
      successCallback,
      errorCallback
    );
  }

  /**
   * 
   * MAIN REQUEST
   * 
   *
   * IMPORTANT:
   *
   * RequestFactory no longer owns its own refreshPromise.
   *
   * SessionManager is the single refresh owner.
   */

  async request(url, config, successCallback, errorCallback, isRetry = false) {
    const requestId = this.getRequestId();

    /**
     * Capture refresh version when this request starts.
     */
    const requestRefreshVersion = getRefreshVersion();

    this.debugLog(`[${requestId}] REQUEST START`, {
      url,
      method: config?.method,
      isRetry,
      requestRefreshVersion,
    });

    try {
      const response = await this.fetchWithXsrf(url, config);

      this.debugLog(`[${requestId}] RESPONSE`, {
        url,
        status: response.status,
        isRetry,
      });

      /**
       * 
       * 401
       * 
       */

      if (response.status === 401 && !isRetry) {
        this.debugWarn(`[${requestId}] 401 RECEIVED`);

        try {
          /**
           * Shared refresh.
           *
           * If another API already refreshed:
           *
           * refreshVersion changes
           *
           * and this request will skip
           * another refresh.
           */
          const refreshResult = await refreshSessionIfNeeded(
            requestRefreshVersion
          );

          if (!refreshResult || !refreshResult.ok) {
            throw refreshResult?.error || new Error('Session refresh failed');
          }

          this.debugLog(`[${requestId}] REFRESH SUCCESS - RETRYING REQUEST`);

          /**
           * Retry original request once.
           */
          return this.request(
            url,
            config,
            successCallback,
            errorCallback,
            true
          );
        } catch (refreshError) {
          this.debugError(`[${requestId}] REFRESH FAILED`, refreshError);

          /**
           * Shared logout.
           *
           * Multiple 401 requests will
           * only logout once.
           */
          this.logoutOnce();

          return;
        }
      }

      /**
       * 
       * NORMAL RESPONSE
       * 
       */
      const parsedResponse = await this.responseParser()(response);
      this.successCallback(successCallback)(parsedResponse);
      this.debugLog(`[${requestId}] REQUEST SUCCESS`);
    } catch (error) {
      this.debugError(`[${requestId}] REQUEST ERROR`, error);
      this.errorCallback(errorCallback)(error);
    }
  }

  /**
   * 
   * FETCH WITH XSRF
   * 
   *
   * RequestFactory delegates XSRF handling to SessionManager.
   *
   * SessionManager handles:
   *
   * - XSRF bootstrap
   * - in-flight API tracking
   * - refresh synchronization
   * - logout synchronization
   */

  async fetchWithXsrf(url, config = {}, xsrfTokenOverride = null) {
    return sharedFetchWithXsrf((xsrfToken) =>
      this.performFetch(url, config, xsrfTokenOverride || xsrfToken)
    );
  }

  /**
   * 
   * ACTUAL FETCH
   * 
   */

  async performFetch(url, config = {}, xsrfToken = null) {
    const headers = new Headers(config.headers || {});

    const method = (config.method || 'GET').toUpperCase();

    /**
     * Add XSRF to state-changing requests.
     */
    if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
      if (xsrfToken) {
        headers.set('X-XSRF-TOKEN', xsrfToken);

        this.debugLog('XSRF HEADER ATTACHED:', {
          method,
          url,
        });
      } else {
        this.debugWarn('STATE CHANGING REQUEST WITHOUT XSRF TOKEN:', {
          method,
          url,
        });
      }
    }

    /**
     * Cookie based authentication.
     *
     * Do not manually send Authorization.
     */
    headers.delete('Authorization');

    headers.delete('authorization');

    this.debugLog('FETCH:', {
      method,
      url,
      credentials: 'include',
      hasXsrfHeader: Boolean(headers.get('X-XSRF-TOKEN')),
    });

    return fetch(url, {
      ...config,
      headers,
      credentials: 'include',
    });
  }

  /**
   * 
   * GET XSRF TOKEN
   * 
   *
   * Kept for backward compatibility.
   *
   * New XSRF synchronization is owned by SessionManager.
   */

  getXsrfToken() {
    const xsrfCookie = document.cookie
      .split('; ')
      .find((row) => row.startsWith('XSRF-TOKEN='));

    if (!xsrfCookie) {
      return null;
    }

    try {
      return decodeURIComponent(xsrfCookie.substring('XSRF-TOKEN='.length));
    } catch (error) {
      this.debugWarn('Unable to decode XSRF cookie');

      return null;
    }
  }

  /**
   * 
   * REFRESH SESSION
   * 
   *
   * Backward-compatible wrapper.
   *
   * The actual refresh lock is owned by SessionManager.
   */
  async refreshSession(requestRefreshVersion = getRefreshVersion()) {
    return refreshSessionIfNeeded(requestRefreshVersion);
  }

  /**
   * 
   * LOGOUT
   *
   * Backward-compatible wrapper.
   *
   * Actual logout synchronization is owned by SessionManager.
   */
  logoutOnce() {
    sharedLogoutOnce();
  }

  /**
   * 
   * RESPONSE PARSER
   * 
   */
  responseParser() {
    return async (response) => {
      /**
       * 401.
       *
       * Normally handled inside request().
       */
      if (response.status === 401) {
        const error = await response.json().catch(() => ({
          message: 'Unauthorized',
        }));

        throw error;
      }

      /**
       * Other HTTP errors.
       */
      if (response.status >= 400 && response.status < 600) {
        const error = await response.json().catch(() => ({
          message: 'Request failed',
        }));

        throw error;
      }

      /**
       * JSON response.
       */
      const contentType = response.headers.get('content-type');

      if (contentType && contentType.indexOf('application/json') !== -1) {
        return response.json();
      }

      /**
       * Existing behavior for
       * missing content type.
       */
      if (contentType === null) {
        return response.json().catch(() => null);
      }

      /**
       * Blob response.
       */
      return response.blob();
    };
  }

  /**
   * 
   * SUCCESS CALLBACK
   * 
   */
  successCallback(callback) {
    return (json) => {
      if (json && Object.prototype.hasOwnProperty.call(json, 401)) {
        if (json.message === 'Enter Valid Credentials') {
          toastr.error(json.message);
        } else {
          this.logoutOnce();
        }
      } else if (
        Utility.isObject(json) &&
        json.message === 'Token Not Available'
      ) {
        this.logoutOnce();
      } else if (typeof callback === 'function') {
        callback(json);
      }
    };
  }

  /**
   * 
   * ERROR CALLBACK
   * 
   */
  errorCallback(callback) {
    return (response) => {
      /**
       * Authentication refresh is
       * handled inside request().
       */

      if (
        response &&
        response.errors &&
        response.errors.message === 'Authentication failed'
      ) {
        // Refresh handled in request().
      }

      /**
       * Do not automatically logout
       * for network errors.
       */
      if (
        response instanceof TypeError &&
        this.isFetchFailure(response.message)
      ) {
        // Network error.
      }

      if (typeof callback === 'function') {
        callback(response);
      }
    };
  }

  /**
   * 
   * BUILD QUERY PARAMS
   * 
   */
  buildQueryParams(queryParams = {}) {
    const params = new URLSearchParams();
    Object.keys(queryParams).forEach((key) => {
      const value = queryParams[key];

      if (typeof value === 'undefined') {
        return;
      }

      /**
       * Preserve existing behavior
       * for object query params.
       */
      if (typeof value === 'object' && value !== null) {
        Object.keys(value).forEach((nestedKey) => {
          const nestedValue = value[nestedKey];

          if (typeof nestedValue !== 'undefined') {
            params.append(`${key}[${nestedKey}]`, nestedValue);
          }
        });
      } else {
        params.append(key, value);
      }
    });

    const queryString = params.toString();

    return queryString ? `?${queryString}` : false;
  }

  /**
   * 
   * GET URL
   * 
   */
  getUrl(path, queryParams) {
    let url = this.getBaseApiUrl();
    let baseUrl = `${url}/${path}`;

    /**
     * V3 APIs.
     */
    if (
      path.includes('tk3') ||
      path.includes('customerdatashare') ||
      path.includes('point-of-interest') ||
      path.includes('customer-onboarding')
    ) {
      url = Env.getEnv(RequestFactory.services.V3_API);
      baseUrl = `${url}/${path}`;
    }
    return queryParams ? baseUrl + this.buildQueryParams(queryParams) : baseUrl;
  }

  /**
   * 
   * GENERIC CALL
   * 
   *
   * Kept for backward compatibility.
   */
  call(type, url, data, successCallback, errorCallback, queryParams) {
    const method = type.toUpperCase();

    /**
     * GET does not need request body.
     */
    if (method === 'GET') {
      return this.request(
        this.getUrl(url, queryParams),
        {
          method: 'GET',
          headers: this.getHeaders(),
          mode: 'cors',
        },
        successCallback,
        errorCallback
      );
    }

    /**
     * Do not manually set Content-Type
     * for FormData.
     */
    if (
      this.requestBodyType === RequestFactory.REQUEST_BODY_TYPE_IMAGE ||
      this.requestBodyType === RequestFactory.REQUEST_BODY_TYPE_FORM_DATA
    ) {
      this.removeHeaders('Content-Type');
    } else {
      this.setHeaders('Content-Type', 'application/json;charset=UTF-8');
    }

    return this.request(
      this.getUrl(url, queryParams),
      {
        method,
        headers: this.getHeaders(),
        body: this.getRequestBody(data),
      },
      successCallback,
      errorCallback
    );
  }
}

export default new RequestFactory();
